import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth } from '../../firebase';
import { sendEmailVerification, signOut } from 'firebase/auth';
import { IconShieldCheck, IconMail } from '@tabler/icons-react';
import AuthShell from '../../components/auth/AuthShell';
import { slides, PRODUCT_LABEL } from '../../components/auth/slides';

export default function EmailVerification() {
  const navigate = useNavigate();
  const [resending, setResending] = useState(false);
  const [resent, setResent] = useState(false);

  const handleResend = async () => {
    if (!auth.currentUser) return;
    setResending(true);
    try {
      await sendEmailVerification(auth.currentUser);
      setResent(true);
      setTimeout(() => setResent(false), 5000);
    } catch (err) {
      console.error(err);
    }
    setResending(false);
  };

  const handleSignOut = async () => {
    await signOut(auth);
    navigate('/login');
  };

  return (
    <AuthShell productLabel={PRODUCT_LABEL} slides={slides}>

        <div style={{ fontSize: 22, fontWeight: 400, color: 'var(--color-text-primary)', marginBottom: 6 }}>
          Verify your email
        </div>
        <div style={{ fontSize: 13, color: 'var(--color-text-tertiary)', marginBottom: 28 }}>
          One more step before you get started
        </div>

        <div style={{
          background: 'var(--color-bg-primary)',
          borderRadius: '0 0 var(--radius-xl) var(--radius-xl)',
          border: '0.5px solid var(--color-border-light)',
          borderTop: 'none',
          padding: '28px',
          textAlign: 'center',
        }}>
          <div style={{
            width: 52,
            height: 52,
            borderRadius: '50%',
            background: 'var(--color-brand-light)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 16px',
          }}>
            <IconMail size={24} color="var(--color-brand)" stroke={1.5} />
          </div>

          <div style={{ fontSize: 15, fontWeight: 400, marginBottom: 8 }}>
            Check your inbox
          </div>
          <div style={{
            fontSize: 13,
            color: 'var(--color-text-tertiary)',
            lineHeight: 1.6,
            marginBottom: 24,
          }}>
            We've sent a verification link to <strong>{auth.currentUser?.email}</strong>.
            Click the link in the email to activate your account.
          </div>

          {resent && (
            <div style={{
              background: 'var(--color-success-light)',
              border: '0.5px solid var(--color-success)',
              borderRadius: 'var(--radius-md)',
              padding: '8px 14px',
              fontSize: 12,
              color: 'var(--color-success)',
              marginBottom: 16,
            }}>
              Verification email resent
            </div>
          )}

          <button
            onClick={handleResend}
            disabled={resending}
            style={{
              width: '100%',
              background: 'var(--color-brand)',
              color: '#fff',
              border: 'none',
              borderRadius: 'var(--radius-md)',
              padding: '11px',
              fontSize: 14,
              cursor: resending ? 'not-allowed' : 'pointer',
              opacity: resending ? 0.7 : 1,
              marginBottom: 10,
            }}
          >
            {resending ? 'Sending...' : 'Resend verification email'}
          </button>

          <button
            onClick={handleSignOut}
            style={{
              width: '100%',
              background: 'transparent',
              color: 'var(--color-text-tertiary)',
              border: '0.5px solid var(--color-border-medium)',
              borderRadius: 'var(--radius-md)',
              padding: '11px',
              fontSize: 13,
              cursor: 'pointer',
            }}
          >
            Sign out
          </button>
        </div>
    </AuthShell>
  );
}